import e from "../../../../node_modules/lodash-es/map.js";
import n from "../../../../node_modules/lodash-es/mapValues.js";
import o from "../../../../node_modules/lodash-es/pick.js";
import { getNullableField as a } from "../../../../common/utils/getNullableField.js";
const i = (e2) => "" === e2 ? null : e2, t = (e2) => parseFloat(e2), r = (r2) => {
  const s = a(r2), m = { ...o(r2, ["id", "factoryNumber", "equipmentModel", "isAtypical", "isReserve", "maintenanceEndDate", "equipmentGroupId"]), amount: t(s("amount")), efficiency: t(s("efficiency")), heatingArea: t(s("heatingArea")), hourlyCost: t(s("hourlyCost")), power: t(s("power")), equipmentTypeId: s("equipmentType.id"), equipmentManufacturerId: s("equipmentManufacturer.id"), maintenanceEndDate: s("maintenanceEndDate"), gasMeteringNodeIds: (d = s("gasMeteringNodes"), e(d, "id")), serviceOrganizationId: s("serviceOrganizationId") };
  var d;
  return n(m, i);
};
export {
  r as getRequestBody
};
//# sourceMappingURL=getRequestBody.js.map
